"use client";

import Script from "next/script";

const DEFAULT_CLARITY_PROJECT_ID = "uyg64fz9q3";

/**
 * Componente para integração do Microsoft Clarity
 * 
 * Carrega o script do Clarity de forma otimizada usando a estratégia afterInteractive
 * do Next.js, que não bloqueia o carregamento inicial da página.
 * 
 * O ID do projeto pode ser configurado via variável de ambiente NEXT_PUBLIC_CLARITY_PROJECT_ID
 * ou usa o valor padrão fornecido.
 */
export function ClarityScript() {
  const projectId =
    process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID || DEFAULT_CLARITY_PROJECT_ID;

  return (
    <Script
      id="microsoft-clarity"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${projectId}");
        `,
      }}
    />
  );
}
